import { BaseModel } from './utility.models';

export interface IContactModel {
    id: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    title: string;
    salutation: string;
    isActive: boolean;
    timestamp: Date;
}

// <editor-fold> Document models

export class ContactModel implements IContactModel {
    id: string = null;
    firstName: string = null;
    lastName: string = null;
    phone: string = null;
    email: string = null;
    title: string = null;
    salutation: string = null;
    isActive: boolean = true;
    timestamp: Date = null;
}

// </editor-fold>
